<template>
  <div>
    <div class="numeric-keypad">
      <v-btn
        v-for="num in numPads"
        :key="num"
        fab
        dark
        class="numeric-keypad-btn"
        :outlined="true"
        @click="press(num)"
      >
        {{ num }}
      </v-btn>
    </div>

    <audio ref="myAudio" autoload>
      <source :src="voiceDtmfTone" type="audio/wav" />
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import dtmf0 from '@/assets/dtmf_tone/dtmf-0.wav'
import dtmf1 from '@/assets/dtmf_tone/dtmf-1.wav'
import dtmf2 from '@/assets/dtmf_tone/dtmf-2.wav'
import dtmf3 from '@/assets/dtmf_tone/dtmf-3.wav'
import dtmf4 from '@/assets/dtmf_tone/dtmf-4.wav'
import dtmf5 from '@/assets/dtmf_tone/dtmf-5.wav'
import dtmf6 from '@/assets/dtmf_tone/dtmf-6.wav'
import dtmf7 from '@/assets/dtmf_tone/dtmf-7.wav'
import dtmf8 from '@/assets/dtmf_tone/dtmf-8.wav'
import dtmf9 from '@/assets/dtmf_tone/dtmf-9.wav'
import dtmfStar from '@/assets/dtmf_tone/dtmf-star.wav'
import dtmfSharp from '@/assets/dtmf_tone/dtmf-sharp.wav'

export default {
  name: 'DialPad',
  data() {
    return {
      numPads: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'],
      voiceDtmfTone: ''
    }
  },
  methods: {
    ...mapActions('call', ['pressNumPad']),
    press(keypad) {
      this.dtmfTone(keypad)
      this.pressNumPad(keypad)
      this.$emit('dtmf', null)
    },
    dtmfTone(keypad) {
      this.voiceDtmfTone = this.getVoice(keypad)
      if (this.voiceDtmfTone) {
        this.$refs.myAudio.load()
        setTimeout(() => this.$refs.myAudio.play(), 100)
      }
    },
    getVoice(keypad) {
      let voice = ''

      switch (keypad) {
        case '0':
          voice = dtmf0
          break
        case '1':
          voice = dtmf1
          break
        case '2':
          voice = dtmf2
          break
        case '3':
          voice = dtmf3
          break
        case '4':
          voice = dtmf4
          break
        case '5':
          voice = dtmf5
          break
        case '6':
          voice = dtmf6
          break
        case '7':
          voice = dtmf7
          break
        case '8':
          voice = dtmf8
          break
        case '9':
          voice = dtmf9
          break
        case '*':
          voice = dtmfStar
          break
        case '#':
          voice = dtmfSharp
          break
        default:
          break
      }

      return voice
    }
  }
}
</script>

<style lang="scss" scoped>
.numeric-keypad {
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: 40px 40px 40px;
  grid-gap: 2px;
}
.numeric-keypad-btn {
  width: 40px;
  height: 40px;
  font-weight: bold;
  color: $text-color;
}
</style>
